import React, { FC } from "react";
import { Breadcrumb, BreadcrumbProps } from "./Breadcrumb";

export type Crumb = {
  isLastOrSingle?: boolean;
  url: string;
  label: string;
};

export type BreadcrumbsProps = {
  breadcrumbs: BreadcrumbProps[];
};

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ breadcrumbs }) => (
  <div className="flex gap-sm">
    {breadcrumbs?.map((crumb, i) => (
      <Breadcrumb key={i} {...crumb} />
    ))}
  </div>
);
